import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useMemo } from 'react';
const TorpedoItem = ({ layoutItem, dataItem, renderItem })=>{
    const itemStyle = {
        width: layoutItem.width,
        height: layoutItem.height
    };
    const wrapStyles = {
        width: layoutItem.width,
        height: '100%',
        display: 'inline-block',
        float: 'left',
        position: 'relative',
        margin: layoutItem.margins
    };
    const mergedItem = useMemo(()=>_object_spread_props(_object_spread({}, layoutItem), {
            dto: _object_spread({}, layoutItem.dto, dataItem)
        }), [
        layoutItem,
        dataItem
    ]);
    // TODO kill the first param of the callback
    return /*#__PURE__*/ React.createElement("div", {
        style: wrapStyles
    }, dataItem ? renderItem({}, mergedItem, itemStyle) : /*#__PURE__*/ React.createElement("div", {
        style: itemStyle
    }));
};
TorpedoItem.displayName = 'TorpedoItem';
export default TorpedoItem;

//# sourceMappingURL=TorpedoItem.js.map